import { supabase } from "@/supabase";
import { ordenarArrayDeObjetos } from "@/utils/ordenarArrayDeObjetos";

export async function loadEstudantesDaTurma(idDaTurma){
    const {data, error} = await supabase
    .from('estudantes_turmas')
    .select('users(id, nome, email_teams, genero, img)')
    .eq('idDaTurma', idDaTurma)


    if(error){
        return error;
    }
    const estudantesFormatados = formatarDadosEstudantes(data);
    return ordenarArrayDeObjetos(estudantesFormatados, 'nome')

}

function formatarDadosEstudantes(data){

    return data.map(item => ({ id: item.users.id, nome: item.users.nome, email_teams: item.users.email_teams, genero: item.users.genero, img: item.users.img }))
}


export async function loadAvaliacoesDosEstudantesNoPlano(idsDosEstudantes, avaliacoesDoPlano){
    console.log(idsDosEstudantes);
    const {data, error} = await supabase    
    .from('planos_notas')
    .select('avaliacao, estudante, nota')
    .in('estudante', idsDosEstudantes)
    .in('avaliacao', avaliacoesDoPlano)


    if(error){
        return error;
    }
    return data;
}